import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation DeleteDocument($documentId: String!) {
    deleteDocument(documentId: $documentId) {
      success
    }
  }
`;

export type DeleteFn = (documentId: string) => void;

export type CompletedFn = () => void;

interface Props {
  onCompleted?: CompletedFn;
  children: (
    execute: DeleteFn,
    loading: boolean,
    done: boolean
  ) => React.ReactNode;
}

const DeleteDocumentProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={() =>
        props.onCompleted ? props.onCompleted() : null
      }
    >
      {(mutateFn, result) =>
        props.children(
          (documentId: string) => mutateFn({ variables: { documentId } }),
          result.loading,
          result.data && result.data.deleteDocument && result.data.deleteDocument.success
        )
      }
    </AuthorizedMutation>
  );
};

export default DeleteDocumentProvider;



// WEBPACK FOOTER //
// ./src/providers/DeleteDocumentProvider.tsx